module.exports = __webpack_public_path__ + "img/background_education.2110105c.png";